import { IFormSchema } from '@publishing-engine/domain/models/form-schema';
import { ComponentName } from '@publishing-engine/domain/types';

/**
 * Simple wrapper around getter for form fields
 */
export class GenericFormFields {
  private form: IFormSchema;

  constructor(form: IFormSchema) {
    this.form = form;
  }

  hasField<CN extends ComponentName>(componentName: CN) {
    return (
      this.form.formFields?.some(cfg => cfg.name === componentName) ?? false
    );
  }

  getFieldConfig<CN extends ComponentName>(componentName: CN) {
    return (
      this.form.formFields?.find(cfg => cfg.name === componentName) ?? null
    );
  }
}
